import * as React from "react";
import { createThirdwebClient, getContract, toUnits } from "thirdweb";
import { ConnectButton, useActiveAccount, useSendAndConfirmTransaction } from "thirdweb/react";
import { mainnet } from "thirdweb/chains";
import Flex from "antd/es/flex";
import { createWallet } from "thirdweb/wallets";
import Button from "antd/es/button";
import message from "antd/es/message";
import Spin from "antd/es/spin";
import { transfer } from "thirdweb/extensions/erc20";
import MoneyCollectOutlined from "@ant-design/icons/MoneyCollectOutlined";
import settings from "../settings.json";
import { FormModel } from "./types";
import { decimals, thirdwebWallets } from "./constants";
import { truncate } from "./utils";
import { useVerifyReserves } from "./useVerifyReserves";

const client = createThirdwebClient({
    clientId: settings.thirdwebId,
});

export interface ThirdwebPayButtonProps {
    formModel: FormModel;
    setTransactionId: (txId: string) => void;
}

export const ThirdwebPayButton: React.FunctionComponent<ThirdwebPayButtonProps> = (props) => {
    const [api, contextHolder] = message.useMessage();
    const address = props.formModel.token === "LLD" ? settings.lld.eth : settings.usdt.eth;
    const account = useActiveAccount();
    const contract = getContract({
        client: client,
        chain: mainnet,
        address,
    });
    const { mutateAsync, isPending, isError, isSuccess } = useSendAndConfirmTransaction();
    const verify = useVerifyReserves();

    const onPay = async () => {
        try {
            const tx = transfer({
                amountWei: toUnits(props.formModel.fromAmount, decimals.Ethereum[props.formModel.token]),
                contract,
                to: settings.seller.eth,
            });
            const verified = await verify.mutateAsync(props.formModel);
            if (!verified) {
                api.error("Not enough reserves, try again later");
                return;
            }
            const {
                transactionHash
            } = await mutateAsync(tx);
            props.setTransactionId(transactionHash);
        } catch (e) {
            console.error(e);
            api.error("Transaction failed");
        }
    };

    return (
        <Flex wrap gap="15px" justify="center" align="center" flex={1}>
            {contextHolder}
            <ConnectButton
                client={client}
                chain={mainnet}
                autoConnect={false}
                detailsButton={{
                    displayBalanceToken: {
                        [mainnet.id]: address,
                    },
                }}
                wallets={thirdwebWallets.map(w => createWallet(w))}
            />
            {account && (
                <Button
                    type="primary"
                    htmlType="button"
                    className="ThirdwebPay ThirdwebPay--payment"
                    onClick={onPay}
                    disabled={isPending || isError || isSuccess}
                    icon={isPending ? <Spin /> : <MoneyCollectOutlined />}
                >
                    Pay with {truncate(account.address)}
                </Button>
            )}
        </Flex>
    );
};
